import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'vshcz-form-label'
})
export class FormLabelDirective {}
